import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["fileInput", "fileNames", "previewContainer", "dropArea"]

  connect() {
    this.addEventListeners()
  }

  addEventListeners() {
    // File input change event
    this.fileInputTarget.addEventListener('change', this.handleFileSelection.bind(this))

    // Drag and drop events
    const dropArea = this.dropAreaTarget

    ;['dragenter', 'dragover', 'dragleave', 'drop'].forEach(eventName => {
      dropArea.addEventListener(eventName, this.preventDefaults.bind(this), false)
    })

    ;['dragenter', 'dragover'].forEach(eventName => {
      dropArea.addEventListener(eventName, this.highlight.bind(this), false)
    })

    ;['dragleave', 'drop'].forEach(eventName => {
      dropArea.addEventListener(eventName, this.unhighlight.bind(this), false)
    })

    dropArea.addEventListener('drop', this.handleDrop.bind(this), false)
  }

  handleFileSelection(e) {
    const files = e.target.files

    if (files.length > 0) {
      this.fileNamesTarget.textContent = `${files.length} ${files.length === 1 ? 'file' : 'files'} selected`

      // Clear previous previews
      this.previewContainerTarget.innerHTML = ''

      // Create preview thumbnails for selected images
      Array.from(files).forEach(file => {
        this.createPreviewForFile(file)
      })
    } else {
      this.fileNamesTarget.textContent = 'No files selected'
      this.previewContainerTarget.innerHTML = ''
    }
  }

  createPreviewForFile(file) {
    const reader = new FileReader()
    reader.onload = (event) => {
      const column = document.createElement('div')
      column.className = 'column is-3'

      const box = document.createElement('div')
      box.className = 'box has-text-centered'

      const figure = document.createElement('figure')
      figure.className = 'image'

      const img = document.createElement('img')
      img.src = event.target.result
      img.style.height = '150px'
      img.style.width = 'auto'
      img.style.margin = '0 auto'
      img.style.objectFit = 'contain'

      const caption = document.createElement('p')
      caption.className = 'mt-2'
      caption.textContent = file.name.length > 20 ?
        file.name.substring(0, 17) + '...' :
        file.name

      figure.appendChild(img)
      box.appendChild(figure)
      box.appendChild(caption)
      column.appendChild(box)
      this.previewContainerTarget.appendChild(column)
    }
    reader.readAsDataURL(file)
  }

  preventDefaults(e) {
    e.preventDefault()
    e.stopPropagation()
  }

  highlight() {
    this.dropAreaTarget.classList.add('is-active')
  }

  unhighlight() {
    this.dropAreaTarget.classList.remove('is-active')
  }

  handleDrop(e) {
    const dt = e.dataTransfer
    const files = dt.files
    this.fileInputTarget.files = files

    // Trigger change event manually
    const event = new Event('change')
    this.fileInputTarget.dispatchEvent(event)
  }
}
